import React, { memo, useState } from 'react';
import { View } from 'react-native';
import Text from 'design-system/Text';
import Image from 'utils/packages/rnFastImage';
import Logo from 'design-system/Logo';
import { Avatar } from 'design-system/avatar';
import { getInitials } from 'design-system/avatar/utils';
import { rem } from 'design-system/values';
import { CIRCLE_BORDER_SIZE, CIRCLE_SIZE } from 'design-system/LogoBankAccount';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import useColorScheme from 'hooks/useColorScheme';
import createStyleSheets from 'utils/createStyleSheets';
const DEFAULT_ICON = 'https://app.emma-cdn.com/images/icons/subscriptions.png';
const HEADER_SIZE = 70;
const HEADER_BORDER = 7.24;
const SubscriptionLogo = ({ name, url, isHeader }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const colorScheme = useColorScheme();
    const [hasError, setHasError] = useState(false);
    const isPlaceholder = !url || url === DEFAULT_ICON;
    if (isHeader) {
        const remSize = rem(HEADER_SIZE);
        const borderRadius = Math.ceil(remSize);
        const contentWidth = remSize - rem(HEADER_BORDER) * 2;
        const sizeStyle = { width: remSize, height: remSize, borderRadius };
        const contentSizeStyle = {
            width: contentWidth,
            height: contentWidth,
            borderRadius,
        };
        const showImage = !isPlaceholder && !hasError;
        return (<View style={styles.headerContainer}>
        {colorScheme === 'light' && (<View style={[styles.headerRing, sizeStyle]}/>)}
        <View style={[styles.headerBorder, sizeStyle]}>
          <View style={[
                styles.headerContent,
                showImage ? styles.headerContentLight : styles.headerContentBrand,
                contentSizeStyle,
            ]}>
            {showImage ? (<Image source={{ uri: url }} resizeMode="contain" onError={() => setHasError(true)} style={contentSizeStyle}/>) : (<Text Text-24 color={colors.text.textOnBrand} style={styles.initials}>
                {getInitials(name || 'Emma')}
              </Text>)}
          </View>
        </View>
      </View>);
    }
    if (isPlaceholder) {
        return (<Avatar size={CIRCLE_SIZE} borderWidth={CIRCLE_BORDER_SIZE} name={name || 'Emma'} fontColor={colors.text.textOnBrand} color={colors.background.brandLight} medium/>);
    }
    return <Logo uri={url} resizeMode="contain" R44/>;
};
const styleSet = createStyleSheets((colors) => ({
    headerContainer: {
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center',
    },
    headerRing: {
        position: 'absolute',
        backgroundColor: colors.cards.onDark,
    },
    headerBorder: {
        borderWidth: rem(HEADER_BORDER),
        borderColor: colors.background.transparent,
        alignItems: 'center',
        justifyContent: 'center',
    },
    headerContent: {
        overflow: 'hidden',
        alignItems: 'center',
        justifyContent: 'center',
    },
    headerContentLight: {
        backgroundColor: colors.cards.onLight,
    },
    headerContentBrand: {
        backgroundColor: colors.background.brandLight,
    },
    initials: {
        textTransform: 'uppercase',
    },
}));
export default memo(SubscriptionLogo);
